import type { MapProgressData } from '../MapProgress';
import { SAVE_STORAGE_KEY, type SaveProvider } from './SaveProvider';

// Типы Telegram WebApp (TelegramCloudStorage, TelegramWebApp, Window.Telegram) —
// в src/types/telegram.d.ts (глобальный ambient .d.ts). Дубль-декларация удалена.

function getCloudStorage(): TelegramCloudStorage | null {
  return window.Telegram?.WebApp?.CloudStorage ?? null;
}

export class TelegramSaveProvider implements SaveProvider {
  readonly name = 'telegram';

  static isAvailable(): boolean {
    const webApp = window.Telegram?.WebApp;
    if (!webApp?.CloudStorage) return false;
    // telegram-web-app.js создаёт CloudStorage-stub на ЛЮБОМ сайте где подключён —
    // существование объекта ≠ реальный Mini App. initData непустой только при открытии
    // через бота. Без этой проверки на десктопе выбирается Telegram-провайдер вместо
    // LocalStorage, save улетает в никуда, прогресс не персистится.
    if (!webApp.initData) return false;
    return true;
  }

  save(data: MapProgressData): Promise<void> {
    return new Promise((resolve, reject) => {
      const cs = getCloudStorage();
      if (!cs) {
        reject(new Error('Telegram CloudStorage not available'));
        return;
      }
      const json = JSON.stringify(data);
      cs.setItem(SAVE_STORAGE_KEY, json, (err, success) => {
        if (err) reject(err);
        else if (!success) reject(new Error('Telegram CloudStorage: setItem returned false'));
        else resolve();
      });
    });
  }

  load(): Promise<MapProgressData | null> {
    return new Promise((resolve, reject) => {
      const cs = getCloudStorage();
      if (!cs) {
        reject(new Error('Telegram CloudStorage not available'));
        return;
      }
      cs.getItem(SAVE_STORAGE_KEY, (err, value) => {
        if (err) {
          reject(err);
          return;
        }
        if (!value) {
          resolve(null);
          return;
        }
        try {
          resolve(JSON.parse(value) as MapProgressData);
        } catch {
          // Битый JSON → трактуем как «нет сохранения», игрок начинает заново.
          resolve(null);
        }
      });
    });
  }

  clear(): Promise<void> {
    return new Promise((resolve, reject) => {
      const cs = getCloudStorage();
      if (!cs) {
        reject(new Error('Telegram CloudStorage not available'));
        return;
      }
      cs.removeItem(SAVE_STORAGE_KEY, (err) => {
        if (err) reject(err);
        else resolve();
      });
    });
  }
}
